import { LayaEnv } from "../../LayaEnv";
import { UIEvent } from "./UIEvent";
export class WidgetRef {
    static create(oldVal, target, callback) {
        if (oldVal)
            oldVal.destroy();
        if (target)
            return new WidgetRef(target, callback);
        else
            return null;
    }
    constructor(val, callback) {
        this.p = val;
        if (!LayaEnv.isPlaying) {
            val.on(UIEvent.InstanceReload, this, this._reload);
            this._callback = callback;
        }
    }
    destroy() {
        if (!LayaEnv.isPlaying)
            this.p.off(UIEvent.InstanceReload, this, this._reload);
    }
    _reload(newIns) {
        this.p = newIns;
        this._callback();
    }
}
